const keys = {
    prod: 'key_live_nfwlg2V4nUnAtIehHW61zafgCAnYnfZV',
    preprod: 'key_test_oiFhlWI6nQmEwMbiP381AhogzzaXgb01'
}
console.log('loading banner script');
(function (b, r, a, n, c, h, _, s, d, k) {
    if (!b[n] || !b[n]._q) {
        for (; s < _.length;) c(h, _[s++]);
        d = r.createElement(a);
        d.async = 1;
        d.src = "https://cdn.branch.io/branch-latest.min.js";
        k = r.getElementsByTagName(a)[0];
        k.parentNode.insertBefore(d, k);
        b[n] = h
    }
})(window, document, "script", "branch", function (b, r) {
    b[r] = function () {
        b._q.push([r, arguments])
    }
}, {
    _q: [],
    _v: 1
}, "addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking getBrowserFingerprintId".split(" "), 0);
const initialize = () => {
    let key;
    let href = window.location.href;
    if (href.indexOf("beta.shutterfly.com") > -1 || href.indexOf("kappa.shutterfly.com") > -1 || href.indexOf("stage.shutterfly.com") > -1) {
        key = keys.preprod;
    } else if (
        href.indexOf("localhost") > -1 ||
        href.indexOf("dev.shutterfly.com") > -1 ||
        href.indexOf("share.shutterfly.com") > -1
    ) {
        key = keys.preprod;
    } else {
        key = keys.prod;
    }
    setTimeout(function () {
        console.log('initializing banner');
        branch.init(key);
    }, 0);

}

export default initialize;